import { render, staticRenderFns } from "./TimeOffDetail.vue?vue&type=template&id=112bf10c&scoped=true"
import script from "./TimeOffDetail.vue?vue&type=script&lang=js"
export * from "./TimeOffDetail.vue?vue&type=script&lang=js"
import style0 from "./TimeOffDetail.vue?vue&type=style&index=0&id=112bf10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112bf10c",
  null
  
)

export default component.exports